import { Component, OnInit, ViewChild, ElementRef, OnDestroy, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { customerConfig, getDirectLoginClpResponse } from '@uxdf/direct-shared-lib';
import { ClpLoginResponse } from '@seco/login';
import { filter, map } from 'rxjs/operators';
import { State } from '../../../redux/reducers/customer';

@Component({
  standalone: false,
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomepageComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('backgroundImage', { static: false }) backGroundImageDiv: ElementRef;
  welcomeUserString = '';
  imageLoadInterval: any;
  isMessageDisplay: string;
  baseUrl = '/assets/images/background/';

  images: string[] = [
    `${this.baseUrl}UK.jpg`,
    `${this.baseUrl}greece.jpg`,
    `${this.baseUrl}turkey.jpg`,
    `${this.baseUrl}bangkok-cityscape-sunset.jpg`,
    `${this.baseUrl}group-of-elephants-chasing-photographers.jpg`,
    `${this.baseUrl}hong-kong-city-in-sunrise-during-shopping-sale-season-in-hong-kong.jpg`,
    `${this.baseUrl}mt-cook-at-sunset-reflected-in-lake-new-zealand.jpg`,
    `${this.baseUrl}namibia-prairie-landscape.jpg`,
    `${this.baseUrl}pincushion-protea.jpg`,
    `${this.baseUrl}rice-terraces-of-longji-titian-near-ping-an-china.jpg`,
    `${this.baseUrl}twilight-landscape-of-horseshoe-bend-colorado-river-arizona-usa.jpg`,
    `${this.baseUrl}winding-oxbow-lakes-in-a-lush-green-landscape.jpg`,
    `${this.baseUrl}window-seat-view.jpg`,
    `${this.baseUrl}gardens-by-the-bay.jpg`,
    `${this.baseUrl}golden-gate-bridge-view.jpg`,
    `${this.baseUrl}lavender-and-trees-uphill-provence-france.jpg`,
    `${this.baseUrl}the-easter-island-moi-at-ahu-tongariki.jpg`,
    `${this.baseUrl}westminster.jpg`,
    `${this.baseUrl}architecture_mea.jpg`,
    `${this.baseUrl}monument_mea.jpg`,
    `${this.baseUrl}nature_mea.jpg`,
    `${this.baseUrl}pillars_mea.jpg`
  ];
  loginUserName = '';
  public customerConfig$: Observable<State>;
  public defaultBg = '';
  private readonly clpLogin: Observable<ClpLoginResponse>;
  private readonly subscriptions: Subscription;

  constructor(private readonly store: Store<any>) {
    // Set default/initial bg image url
    this.defaultBg = this.images[Math.floor(Math.random() * this.images.length)];
    this.loginUserName = '';
    this.clpLogin = this.store.pipe(select(getDirectLoginClpResponse));
    this.subscriptions = new Subscription();
  }

  ngOnInit() {
    this.isMessageDisplay = sessionStorage.getItem('displayMessage') || 'true';
    this.customerConfig$ = this.store.pipe(select(customerConfig));
    this.subscriptions.add(
      this.customerConfig$
        .pipe(
          filter(config => config.customerConfig && !config.isLoading),
          map(config => config.customerConfig)
        )
        .subscribe(config => {
          this.loginUserName = config.name || '';
          this.welcomeUserString = $localize`:@@homepage.welcome-user:Welcome ${this.loginUserName}`;
        })
    );
  }

  ngAfterViewInit() {
    this.setBackgroundImageTimer();
  }

  ngOnDestroy() {
    clearInterval(this.imageLoadInterval);
    this.subscriptions.unsubscribe();
  }

  closeAlert() {
    this.isMessageDisplay = 'false';
    sessionStorage.setItem('displayMessage', this.isMessageDisplay);
  }

  /**
   * Method to start timer to shuffle & display background images
   */
  setBackgroundImageTimer() {
    const div = this.backGroundImageDiv.nativeElement;

    // set interval to change background at specified timeframe
    this.imageLoadInterval = setInterval(() => {
      this.displayBackgroundImage(div);
    }, 120000);
  }

  /**
   * Method to display background image
   */
  displayBackgroundImage(backgroundImageDiv: any) {
    const temporaryImage = new Image();
    temporaryImage.src = this.images[Math.floor(Math.random() * this.images.length)];
    temporaryImage.onload = () => {
      backgroundImageDiv.style.background = `transparent url(${temporaryImage.src})no-repeat center center fixed`;
      backgroundImageDiv.style.backgroundSize = 'cover';
      backgroundImageDiv.style.minHeight = '100%';
    };
  }
}
